function FormatTimeDayMonthYearAMPM(date, type = '') {
  let d;
  if (date) {
    d = new Date(date);
  } else {
    d = new Date();
  }
  const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
  const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
  const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
  let hours = d.getHours();
  let minutes = d.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours %= 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  const strTime = `${hours}:${minutes} ${ampm}`;
  let finaldate = '';
  if (type === 'slash') {
    const month = String(d.getMonth() + 1).length > 1 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`;
    finaldate = `${da}/${month}/${ye}; ${strTime}`;
  }
  if (type === 'slashwithoutTime') {
    const month = String(d.getMonth() + 1).length > 1 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`;
    finaldate = `${da}/${month}/${ye}`;
  } else {
    finaldate = `${da}-${mo}-${ye}, ${strTime}`;
  }
  return finaldate;
}
export { FormatTimeDayMonthYearAMPM };
